import { createSelector } from "reselect";
import { AppState } from "../reducer";

const getApplicants = (state: AppState) => {
  return state.applicants;
};

const getUpdateApplicationStatus = (state: AppState) => {
  return state.applicants.applicationUpdateStatus;
}

export const getApplicantsSelector = createSelector(getApplicants, (getApplicants) => getApplicants);
export const getUpdateApplicationSelector = createSelector(getUpdateApplicationStatus, (getUpdateApplicationStatus) => getUpdateApplicationStatus);

export const getErrorMessageSelector = createSelector(
  getApplicants, 
  (applicants) => applicants.response
);
